<template>
  <header class="app-header">
    <div class="header-left">
      <svg class="logo" viewBox="0 0 32 32" width="30" height="30" aria-hidden="true">
        <defs>
          <linearGradient id="logo-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#1c4d3a"/><stop offset="1" stop-color="#123527"/>
          </linearGradient>
        </defs>
        <circle cx="16" cy="16" r="15" fill="url(#logo-g)"/>
        <path d="M7 20 L13 11 L17 17 L20 13 L25 20 Z" fill="#fff"/>
        <path d="M7 23 h18" stroke="#d9bc7d" stroke-width="2.4" stroke-linecap="round"/>
      </svg>
      <div class="header-name">
        <span class="platform-name">{{ APP_NAME }}</span>
        <span class="platform-sub">{{ APP_SUBTITLE }}</span>
      </div>
    </div>

    <nav class="header-nav">
      <a class="nav-item" :class="{ active: isActive('/intro') }" href="javascript:void(0)" @click="nav('/intro')">平台简介</a>
      <a class="nav-item" :class="{ active: isActive('/policies') }" href="javascript:void(0)" @click="nav('/policies')">资产政策</a>
      <a class="nav-item" :class="{ active: isActive('/cases') }" href="javascript:void(0)" @click="nav('/cases')">典型案例</a>
      <a class="nav-item" :class="{ active: isActive('/home') || isActive('/') }" href="javascript:void(0)" @click="nav('/home')">机会地图</a>
      <a class="nav-item" :class="{ active: isActive('/promo') }" href="javascript:void(0)" @click="nav('/promo')">资源推介</a>
      <a class="nav-item" :class="{ active: isActive('/about') }" href="javascript:void(0)" @click="nav('/about')">关于我们</a>
      <a class="nav-item" :class="{ active: isActive('/contact') }" href="javascript:void(0)" @click="nav('contact')">联系我们</a>
    </nav>

    <div class="header-right">
      <button v-if="!auth.loggedIn" class="btn btn-primary btn-sm" @click="emit('open-login')">登录 / 注册</button>
      <div v-else class="user-chip">
        <span class="user-avatar" :title="auth.hasNickname ? auth.displayName + '（' + auth.phoneMasked + '）' : auth.phoneMasked">{{ avatarText }}</span>
        <span class="user-phone" :title="auth.phoneMasked">{{ auth.displayName }}</span>
        <button class="logout-link" @click="auth.logout()">退出</button>
        <!-- 空闲配额提醒小红点：点击进入个人信息面板 -->
        <button
          v-if="auth.hasIdleQuota"
          class="idle-badge"
          :title="`您有 ${auth.idleQuota} 个空余的机会帐资料配额，点击进入个人信息设置区域`"
          @click="openProfile"
        >{{ auth.idleQuota }}</button>
        <!-- 普通用户下拉菜单：个人信息 -->
        <div v-if="!auth.isAdmin" class="admin-menu" @click.stop>
          <button class="admin-menu-btn" @click="menuOpen = !menuOpen">我的 ▾</button>
          <div v-if="menuOpen" class="admin-menu-dropdown" @click="menuOpen = false">
            <a class="menu-item" @click="openProfile">👤 个人信息</a>
            <div class="menu-info">
              已解锁：{{ auth.quotaUsage?.cityCount ?? 0 }} 个城市 · {{ auth.quotaUsage?.countyCount ?? 0 }} 个区县<br>
              空闲配额：{{ auth.hasAllRegions ? '全部区域' : auth.idleQuota + ' 个' }}
            </div>
          </div>
        </div>
        <!-- 管理员下拉菜单：个人信息 + 管理入口 -->
        <div v-if="auth.isAdmin" class="admin-menu" @click.stop>
          <button class="admin-menu-btn" @click="menuOpen = !menuOpen">管理 ▾</button>
          <div v-if="menuOpen" class="admin-menu-dropdown" @click="menuOpen = false">
            <a class="menu-item" @click="openProfile">👤 个人信息</a>
            <div class="menu-divider"></div>
            <a class="menu-item" @click="nav('/admin/dashboard')">📊 管理面板</a>
            <a class="menu-item" @click="nav('/lead-admin')">👥 留资查看</a>
            <a v-if="auth.isSuperAdmin" class="menu-item" @click="nav('/admin/whitelist')">⚙️ 白名单管理</a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useRouter, useRoute } from 'vue-router';
import { APP_NAME, APP_SUBTITLE } from '@/config/app';
const auth = useAuthStore();
const router = useRouter();
const route = useRoute();
const menuOpen = ref(false);
const emit = defineEmits<{ (e: 'open-login'): void; (e: 'open-contact'): void; (e: 'open-profile'): void }>();

/** 头像文字：昵称首字（无昵称时用「用户」） */
const avatarText = computed(() => {
  const n = auth.profile?.nickname?.trim();
  return n ? n.slice(0, 1) : '用';
});

function nav(to: string) {
  router.push(to.startsWith('/') ? to : '/' + to);
  menuOpen.value = false;
}
function openProfile() {
  menuOpen.value = false;
  emit('open-profile');
}
function isActive(to: string) {
  if (to === '/') return route.path === '/';
  return route.path.startsWith(to);
}
function onClickOutside() { menuOpen.value = false; }
onMounted(() => { document.addEventListener('click', onClickOutside); });
onUnmounted(() => { document.removeEventListener('click', onClickOutside); });
</script>
